/** Cookie с yclid (ставится из inline-скрипта в index.html с URL Директа). */
export const SITE_YCLID_COOKIE_NAME = "virtuoz_yclid";
/** Cookie Яндекс.Метрики с ClientID того же браузера (ставит сам tag.js). */
export const YM_UID_COOKIE_NAME = "_ym_uid";
/**
 * LEGACY: здесь жил синтетический ClientID. Больше не пишется — ключ нужен
 * только чтобы вычистить старое значение (см. yandexMetrikaTagLoader).
 */
export const SITE_METRIKA_CLIENT_ID_KEY = "virtuoz_site_metrika_client_id";
/** Одна отправка «start» за сессию вкладки. */
export const SITE_ANALYTICS_START_SESSION_KEY = "virtuoz_site_analytics_start_sent";
/** ClientID для mc.yandex.ru/collect — только цифры (как у ym getClientID). */
export const METRIKA_NUMERIC_CID_RE = /^\d{10,24}$/;
export function isValidMetrikaNumericCid(value) {
    return Boolean(value && METRIKA_NUMERIC_CID_RE.test(value));
}
const YCLID_RE = /^[a-zA-Z0-9._-]{1,128}$/;
/**
 * yclid с текущего URL или cookie (tag.js не нужен).
 */
export function readVirtuozYclid() {
    if (typeof window === "undefined") {
        return undefined;
    }
    try {
        const m = window.location.search.match(/[?&]yclid=([^&]*)/);
        if (m) {
            const v = decodeURIComponent(m[1].replace(/\+/g, " ")).trim();
            if (v && YCLID_RE.test(v)) {
                return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    try {
        const parts = document.cookie.split(";");
        for (const part of parts) {
            const idx = part.indexOf("=");
            if (idx === -1) {
                continue;
            }
            const name = part.slice(0, idx).trim();
            if (name !== SITE_YCLID_COOKIE_NAME) {
                continue;
            }
            const v = decodeURIComponent(part.slice(idx + 1).trim());
            if (v && YCLID_RE.test(v)) {
                return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    return undefined;
}
/**
 * ClientID из cookie `_ym_uid` (его ставит сам tag.js Метрики). Полезно, когда
 * на текущей загрузке счётчик не поднялся (заблокирован/оффлайн), но Метрика
 * уже работала на прошлых заходах — значение совпадает с ym getClientID.
 */
export function readYmUidCookie() {
    if (typeof document === "undefined") {
        return null;
    }
    try {
        const parts = document.cookie.split(";");
        for (const part of parts) {
            const idx = part.indexOf("=");
            if (idx === -1) {
                continue;
            }
            const name = part.slice(0, idx).trim();
            if (name !== YM_UID_COOKIE_NAME) {
                continue;
            }
            const v = decodeURIComponent(part.slice(idx + 1).trim());
            if (isValidMetrikaNumericCid(v)) {
                return v;
            }
        }
    }
    catch {
        /* ignore */
    }
    return null;
}
